import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BackArrow from '../assets/images/Frame_18177.png';
import axiosInstance from '../api/axiosInstance';
import InactivityTimer from './InactivityTimer';

const PaymentFailure = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const error = query.get('error') || 'Payment failed. Please try again.';
    const orderId = query.get('orderId') || 'N/A';
    const [tariff, setTariff] = useState(0);

    const getVisitTarrif = async () => {
        try {
            const response = await axiosInstance.get('/api/patient/get-visit-tariff');
            if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0 && response.data[0].tariff) {
                setTariff(response.data[0].tariff);
            } else {
                throw new Error('Failed to fetch visit tariff');
            }
        } catch (error) {
            console.error('Error fetching visit tariff:', error);
        }
    };

    useEffect(() => {
        getVisitTarrif();
    }, []);

    const retryPayment = async (order_id) => {
        try {
            // Fetch payment data using the correct endpoint
            const response = await axiosInstance.get(`/api/patient/get-data-by-order-id/${order_id}`);
            if (response.status === 200) {
                const { currency, patientMrno, doctorName } = response.data;

                // Trigger payment using the handlePayment logic
                const handlePayment = async () => {
                    const { data } = await axiosInstance.post('/api/patient/create-order', {
                        amount: tariff * 100, // Retry full amount
                        currency,
                        patientMrno,
                        doctorName,
                    });

                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = 'https://api.razorpay.com/v1/checkout/embedded';

                    const formFields = {
                        key_id: data.key,
                        amount: data.amount.toString(),
                        currency: data.currency,
                        name: "Trauma Centre BHU",
                        description: "Medical Consultation Fee",
                        image: "https://traumacentrebhu.com/static/media/logo.241d0eaa536833244497.jpg",
                        order_id: data.order_id,
                        callback_url: `${axiosInstance.defaults.baseURL}/api/patient/verify-payment`,
                        cancel_url: `${axiosInstance.defaults.baseURL}/api/patient/cancel-payment`,
                        prefill: {
                            name: 'test test', // Use default or fetch from patient data if available
                            email: 'test@gmail.com',
                            contact: '9427388748',
                        },
                        theme: { color: "#0FA968" },
                    };

                    Object.keys(formFields).forEach((key) => {
                        if (typeof formFields[key] === 'object') {
                            Object.keys(formFields[key]).forEach((subKey) => {
                                const input = document.createElement('input');
                                input.type = 'hidden';
                                input.name = `${key}[${subKey}]`;
                                input.value = formFields[key][subKey];
                                form.appendChild(input);
                            });
                        } else {
                            const input = document.createElement('input');
                            input.type = 'hidden';
                            input.name = key;
                            input.value = formFields[key];
                            form.appendChild(input);
                        }
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                };

                await handlePayment();
            } else {
                console.error('Failed to fetch data for retry:', response.data);
                // Optionally show an error message to the user
            }
        } catch (error) {
            console.error('Retry payment error:', error);
            // Optionally show an error message to the user
        }
    };

    return (
        <>
            <InactivityTimer />
            <div className="p-6">
                <div className="flex items-center mb-6">
                    <Link
                        to="/login"
                        className="flex w-28 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
                        style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                    >
                        <img src={BackArrow} alt="Back" className="mr-2 w-6 h-6" />
                        Login
                    </Link>
                    <span
                        className="ml-4 text-2xl font-semibold"
                        style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}
                    >
                        Payment Failure
                    </span>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-xl font-semibold mb-4 text-red-500">Payment Failed</h2>
                    <p className="text-red-500 mb-2">{decodeURIComponent(error)}</p>
                    <p className="text-gray-600 mb-4"><strong>Order ID:</strong> {orderId}</p>
                    <Link
                        to="/"
                        className="px-4 py-2 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
                        style={{ fontFamily: 'Roboto', fontSize: '16px' }}
                    >
                        Home
                    </Link>
                    <button
                        onClick={() => retryPayment(orderId)}
                        className="ml-4 px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow hover:bg-blue-600 transition duration-200"
                        style={{ fontFamily: 'Roboto', fontSize: '16px' }}
                        disabled={!orderId || orderId === 'N/A'}
                    >
                        Retry Payment
                    </button>
                </div>
            </div>
        </>
    );
};

export default PaymentFailure;